import { render, staticRenderFns } from "./pays.vue?vue&type=template&id=ba5691ba&scoped=true&"
import script from "./pays.vue?vue&type=script&lang=js&"
export * from "./pays.vue?vue&type=script&lang=js&"
import style0 from "./pays.vue?vue&type=style&index=0&id=ba5691ba&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5691ba",
  null
  
)

export default component.exports